import React from 'react'

import { TabsBar } from 'components/shared/TabsBar/TabsBar'

type PaneTabsBarProps = Omit<React.ComponentProps<typeof TabsBar>, 'alignment'>

export const PaneTabsBar = ({
  activeTab,
  className,
  tabClassName,
  tabs,
  onClick,
  isScrollable,
}: PaneTabsBarProps) => (
  <TabsBar
    alignment="top-left"
    {...{
      activeTab,
      className,
      tabClassName,
      tabs,
      onClick,
      isScrollable,
    }}
  />
)
